import axios from "axios";
import { ApiLink } from "../../APILink/ApiLink";
import authHeader from "../../Auth/authHeader";

const extractServerMessage = (error, fallback) => {
  const data = error?.response?.data;

  if (typeof data === "string" && data.trim()) return data;
  if (data?.Message) return data.Message;
  if (data?.message) return data.message;
  if (error?.message) return error.message;

  return fallback;
};

export async function fetchArticleById(id) {
  try {
    const response = await axios.get(ApiLink.API_URL + `Article/getArticleEdit/${id}`, {
      headers: authHeader(),
    });
    // Kthejmë të dhënat (Master + Details) që vijnë nga .NET
    return response.data;
  } catch (error) {
    // ExceptionMiddleware do ta kapë këtë në back-end
    throw error;
  }
}

export const createArticle = async (data) => {
  const res = await axios.post(
    `${ApiLink.API_URL}Article/insertArticle`,
    data,
    {
      headers: authHeader(),
    },
  );
  if (!res.data || res.data.toString().toLowerCase().includes("error")) {
    throw new Error(res.data || "Insert failed");
  }
  return res.data;
};

// export const updateArticle = async (data) => {
//   const res = await axios.put(`${ApiLink.API_URL}Article/editGroup`, data, {
//     headers: authHeader(),
//   });
//   if (!res.data || res.data.toString().toLowerCase().includes("error")) {
//     throw new Error(res.data || "Update failed");
//   }
//   return res.data;
// };
export const updateArticle = async (id, data) => {
  try {
    // 1. Përdorim URL-në e re RESTful që krijuam në Controller [id]
    const res = await axios.put(`${ApiLink.API_URL}Article/${id}`, data, {
      headers: authHeader(),
    });

    // 2. Kthejmë direkt të dhënat (success: true, message: "...")
    return res.data;
  } catch (error) {
    const serverMessage = extractServerMessage(
      error,
      "Gabim gjatë përditësimit.",
    );

    // Hedhim gabimin që ta kapë blloku try-catch te handleSubmit
    throw new Error(serverMessage);
  }
};

export const deleteArticle = async (id) => {
  try {
    const res = await axios.delete(`${ApiLink.API_URL}Article/deleteArticle/${id}`, {
      headers: authHeader(),
    });

    // Returns { success: true, message: "Artikulli u fshi me sukses!" }
    return res.data;
  } catch (error) {
    const serverMessage = extractServerMessage(error, "Gabim gjatë fshirjes.");
    throw new Error(serverMessage);
  }
};

